// PolicyEngine color palette
export const palette = {
  BLACK: "#000000",
  BLUE_98: "#F7FAFD",
  BLUE: "#2C6496",
  BLUE_LIGHT: "#D8E6F3",
  BLUE_PRESSED: "#17354F",
  DARK_BLUE_HOVER: "#1d3e5e",
  DARK_GRAY: "#616161",
  DARK_RED: "#b50d0d",
  DARKEST_BLUE: "#0C1A27",
  GRAY: "#808080",
  LIGHT_GRAY: "#F2F2F2",
  MEDIUM_DARK_GRAY: "#D2D2D2",
  MEDIUM_LIGHT_GRAY: "#BDBDBD",
  TEAL_ACCENT: "#39C6C0",
  TEAL_LIGHT: "#F7FDFC",
  TEAL_PRESSED: "#227773",
  WHITE: "#FFFFFF",
};

export type ColorKey = keyof typeof palette;